import { create } from 'zustand'

type NoticeKind = 'success' | 'error' | 'info'

interface Notice {
  id: number
  kind: NoticeKind
  message: string
}

interface UIState {
  notice: Notice | null
  notify: (message: string, kind?: NoticeKind) => void
  clear: () => void
}

let timer = 0

export const useUIStore = create<UIState>((set) => ({
  notice: null,
  notify: (message, kind = 'success') => {
    window.clearTimeout(timer)
    const notice = { id: Date.now(), kind, message }
    set({ notice })
    timer = window.setTimeout(() => set({ notice: null }), 3600)
  },
  clear: () => set({ notice: null }),
}))

